/**
 * 驗證統一編號
 * @param {string} taxId
 * @returns {boolean}
 */
const validateTaxId = (taxId) => {
  // 確保輸入是 8 碼數字
  if (!/^\d{8}$/.test(taxId)) {
    return false
  }

  const weights = [1, 2, 1, 2, 1, 2, 4, 1] // 邏輯乘數

  // 如果第七位是 7
  if (taxId[6] === '7') {
    let totalZ1 = 0
    let totalZ2 = 0
    for (let i = 0; i < taxId.length; i++) {
      const digit = parseInt(taxId[i], 10) // 將第 i 位轉為數字
      const product = digit * weights[i] // 與對應乘數相乘
      const sumTensAndOnes = Math.floor(product / 10) + (product % 10) // 取十位數與個位數相加

      if (i === 6) { // 第 7 位的特殊處理
        totalZ1 += Math.floor(sumTensAndOnes / 10) // 取十位數加到 Z1
        totalZ2 += sumTensAndOnes % 10 // 取個位數加到 Z2
      } else {
        totalZ1 += sumTensAndOnes // 計算 Z1
        totalZ2 += sumTensAndOnes // Z2 和 Z1 一致
      }
    }
    // Z1 或 Z2 可被 5 整除即為有效
    return totalZ1 % 5 === 0 || totalZ2 % 5 === 0
  } else { // 第七位不是 7，則根據一般的邏輯處理
    let total = 0
    for (let i = 0; i < taxId.length; i++) {
      const digit = parseInt(taxId[i], 10) // 將第 i 位轉為數字
      const product = digit * weights[i] // 與對應乘數相乘
      total += Math.floor(product / 10) + (product % 10) // 取十位數與個位數相加
    }
    // 若 total 能被 5 整除，則視為有效
    return total % 5 === 0
  }
}

export {
  validateTaxId
}
